<mat-nav-list>
  <a mat-list-item routerLink="/dashboard" (click)="onClick()">
    <div class="link-item">
      <mat-icon>dashboard</mat-icon>
      <span class="menu-text">{{ 'navigation.dashboard' | transloco }}</span>
    </div>
  </a>

  <a mat-list-item routerLink="/chart" (click)="onClick()">
    <div class="link-item">
      <mat-icon>pie_chart</mat-icon>
      <span class="menu-text">{{ 'navigation.chart' | transloco }}</span>
    </div>
  </a>
</mat-nav-list>
